import auth from '@/middlewares/auth'
import autoLogin  from '@/middlewares/autoLogin'
import routerName from '@/constants/routers'

export default [
    {
        path: '/',
        component: () => import( /* webpackChunkName: "loading-screen" */ './views/layout.vue'),
        children : [
            {
                path: 'loading-screen',
                name: routerName.LOADING_SCREEN,
                meta : {
                    middleware : [ autoLogin , auth ],
                    breadcrumb: [
                        { name: 'Loading Screen' }
                    ]
                },
                component: () => import( /* webpackChunkName: "loading-settings" */ './views/index.vue')
            }
        ]
    }
]